import { UserModel } from "@cakemail-org/ui-components-v2"
import { TGetInitialBeeConfiguration } from "../types"
import { getDefaultMergeTags, getSpecialLinks } from "./mergeTags"
import { getContentDefaults } from "./contentDefaults"
import { getRowDisplayConditions } from "./displayCondition"
import { t } from "i18next"
import { getAddOns, getContentDialogConfig } from "./contentDialogs"

export function getInitialBeeConfiguration({
    reload,
    account,
    user,
    partnerBrand,
    userBrand,
    editorType,
    containerName,
    getContentContext,
    getLocalContent,
    onChange,
    onSaveAsTemplate,
    onAutoSave,
    onSend,
    onLoad,
    onError,
    onWarning
}: TGetInitialBeeConfiguration): any {

    let mergeTags = getDefaultMergeTags({ account })
    let specialLinks = getSpecialLinks()
    let config = {
        uid: account.id, // [mandatory]
        container: containerName, // [mandatory]
        autosave: false,//10, // [optional, default:false]
        language: parseForBeeLanguage(user),
        trackChanges: true, // [optional, default: false]
        specialLinks: specialLinks, // [optional, default:[]]
        mergeTags: mergeTags, // [optional, default:[]]
        mergeContents: [], // [optional, default:[]]
        preventClose: true, // [optional, default:false]
        customCss: "", //"https://storage.googleapis.com/website-scripts/smartEmailBeeOverride.css" : ""
        ...getContentDefaults({ userBrand: userBrand, getContentContext }),
        // was on reload before
    }

    if (!reload) {
        config = {
            ...config,
            rowsConfiguration: {
                emptyRows: true,
                defaultRows: true,
                externalContentURLs: getExternalContentURLs(),
            },
            hooks: getHooksConfig(),

            addOns: getAddOns({ account, partnerBrand, userBrand }),
            contentDialog: getContentDialogConfig({ editorType, getContentContext, getLocalContent }),

            rowDisplayConditions: getRowDisplayConditions(),
            onLoad: (jsonFile: string) => {
                onLoad && onLoad(jsonFile)
            },
            onAutoSave: function (jsonFile: string) {
                onAutoSave && onAutoSave(jsonFile)
            }, // [optional]

            /*onSave: function (jsonFile: string, htmlFile: string) {
                onSave && onSave(jsonFile, htmlFile)
            }, // [optional]*/
            onChange: function (jsonFile: string, response: any) {
                onChange && onChange(jsonFile, response)
                //Codes
                /*
                0120 Text block
                0121
                0374 Button BG
                0320 Button text
                0490 Line
                1120 Menu item
                1121
                1320 Title
                1321
                2220 paragraph
                2221
                2320 List
                2321
                 */

            }, // [optional]
            /* Implements function for save as template (only JSON file) */
            onSaveAsTemplate: (jsonFile: string) => {
                onSaveAsTemplate && onSaveAsTemplate(jsonFile)
            },
            onSend: function (htmlFile: string) {
                onSend && onSend(htmlFile)
            }, // [optional]
            onError: function (errorMessage: string) {
                onError && onError(errorMessage)
            }, // [optional]
            onWarning: function (alertMessage: string) {
                onWarning && onWarning(alertMessage)
            }, // [optional]
        }
    }

    return config
}

function parseForBeeLanguage(user: UserModel) {
    const locale = user.language
    if (locale) {
        switch (locale) {
            case "fr_CA":
                return "fr-FR"
            case "es_US":
                return "es-ES"
            default:
                return locale.replace("_", "-")
        }
    } else {
        return "en-US"
    }
}

export enum ERowCat {
    shared = "shared-row",
    sharedSmart = "shared-smart-row",
    my = "my-row",
    mySmart = "my-smart-row",
};

function getExternalContentURLs() {
    return [
        /*{
            name: I18n.t("app-designer-editors-rows-shared-normal"),
            value: ERowCat.shared,
            handle: ERowCat.shared,
            isLocal: true,
            behaviors: {
                canDelete: false,
            },
        },
        //TODO when permission is available, make this element conditional
        {
            name: I18n.t("app-designer-editors-rows-shared-smart"),
            value: ERowCat.sharedSmart,
            handle: ERowCat.sharedSmart,
            isLocal: true,
            behaviors: {
                canDelete: false,
            },
        },*/
        {
            name: t("app-designer-editors-rows-mine-normal"),
            value: ERowCat.my,
            handle: ERowCat.my,
            isLocal: true,
            behaviors: {
                canEdit: true,
                canDelete: true,
            },
        },
        //TODO when permission is available, make this element conditional
        /*{
            name: t("app-designer-editors-rows-mine-smart"),
            value: ERowCat.mySmart,
            handle: ERowCat.mySmart,
            isLocal: true,
            behaviors: {
                canEdit : true,
                canDelete: true,
            },
        }*/
    ]
}

function getHooksConfig() {
    return {
        getRows: {
            handler: async (resolve, reject, args) => {
                const succ = (data) => {
                    resolve(data.data)
                }
                const failure = () => {
                    reject()
                }
                switch (args.value) {
                    case ERowCat.shared:
                        //getDesignerBlueprintRowsService({}, succ, failure);
                        break
                    case ERowCat.sharedSmart:
                        /*getDesignerBlueprintRowsService(
                            { smart: true },
                            succ,
                            failure
                        );*/
                        break
                    case ERowCat.my:
                        //getDesignerRowsService({}, succ, failure);
                        break
                    case ERowCat.mySmart:
                        //getDesignerRowsService({ smart: true }, succ, failure);
                        break
                }
            }
        }
    }
}